import { StyledDivider } from 'baseui/divider';

export function StyledCardDivider() {
  return (
    <StyledDivider
      $size="cell"
      style={{ marginTop: 0, marginBottom: 0 }}
    />
  );
}
